export const editorStore = 'core/editor';
export const noticesStore = 'core/notices';
export const blockEditorStore = 'core/block-editor';
